import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Stack } from "@mui/material";
import ConfirmationDialog from "./modals/ConfirmationDialog";
import { useQueryClient } from "@tanstack/react-query";
import { useKeycloak } from "@react-keycloak/web";
import { useCreateSession } from "../../../../tanstackQuery/queries/superAdmin/session";
import { toast } from "sonner";

export const SessionActions = ({ ...props }) => {
  const { row, setShowInviteTable, setSelectedRowData } = { ...props };

  const [openDeleteSessionModal, setOpenDeleteSessionModal] = useState(false);
  const client = useQueryClient();
  const { keycloak } = useKeycloak();

  const {
    mutateAsync: deleteSession,
    isPending,
    isSuccess
  } = useCreateSession(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["org-invite-sessions"] });
        setOpenDeleteSessionModal(false);
      },
      onError: (err) => {
        setOpenDeleteSessionModal(false);
      }
    }
  );

  const handleDeleteSession = async () => {
    if (!row) return;
    
    const { created, modified, createdF, modifiedF, ...filteredData } = row;
    const payload = {
      ...filteredData,
      status: "deleted",
    };

    try {
      await deleteSession(payload);
      if (isSuccess) {
        toast.success("Session successfully deleted!");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to delete session."
      );
    }
  };

  return (
    <>
      <Stack spacing={1} direction="column">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setShowInviteTable(true);
            setSelectedRowData(row);
          }}
          size="small"
          sx={{ width: "fit-content" }}
        >
          Open Session
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={() => setOpenDeleteSessionModal(true)}
          size="small"
          sx={{ width: "fit-content" }}
        >
          Delete Session
        </Button>
      </Stack>

      <ConfirmationDialog
        open={openDeleteSessionModal}
        title="Delete Session"
        description="Are you sure you want to delete this session? This action cannot be undone."
        onConfirm={handleDeleteSession}
        onCancel={() => setOpenDeleteSessionModal(false)}
        isPending={isPending}
      />
    </>
  );
};
 
